module.exports = __webpack_public_path__ + "img/default-skin.4c8cdc3f.svg";